
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehiclePart",
      function () {
        return require("private-next-pages/vehiclePart.js");
      }
    ]);
  